import React from 'react';
import SummaryCard from '../SummaryCard';
import { useIotDevicesStore } from './use-iot-devices-store';

const IotDevices = () => {
  const { setShowModal, total } = useIotDevicesStore();
  const iotDeviceStats = [{ title: 'Всего', total }];

  return total > 0 && <SummaryCard handleClick={() => setShowModal(true)} stats={iotDeviceStats} title={'Окончание пакета NB-IoT'} isVisible={true} />;
};

export default IotDevices;
